import { Select } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card } from 'src/components/Card/Card';
import { MerchantSnapshotDto } from 'src/generated-api-client';
import { AgentLoanApplicationMerchantSnapshotSalesTable } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationMerchantSnapshotSalesTable';
import { AgentLoanApplicationSalesType } from 'src/stores/AgentLoanApplicationsStore/AgentLoanApplicationsStore.types';

type LoanApplicationMerchantSnapshotSalesProps = {
    snapshot: MerchantSnapshotDto;
};

export const AgentLoanApplicationMerchantSnapshotSales = observer(
    ({ snapshot }: LoanApplicationMerchantSnapshotSalesProps) => {
        const [filterType, setFilterType] =
            useState<AgentLoanApplicationSalesType>(
                AgentLoanApplicationSalesType.MONTHLY,
            );

        const sales = snapshot?.merchant?.sales || [];

        const filteredSales = useMemo(() => {
            return sales
                .filter(
                    (sale) =>
                        sale.type?.toLowerCase() === filterType.toLowerCase(),
                )
                .sort((a, b) => {
                    if (!a.periodStart || !b.periodStart) {
                        return 0;
                    }

                    return (
                        moment(b.periodStart).valueOf() -
                        moment(a.periodStart).valueOf()
                    );
                });
        }, [sales, filterType]);

        return (
            <Card
                title={t('Agent.LoanApplication.MerchantSnapshot.Sales.Title')}
                extra={
                    <Select
                        value={filterType}
                        onChange={(value) =>
                            setFilterType(
                                value as AgentLoanApplicationSalesType,
                            )
                        }
                        options={salesTypeOptions}
                    />
                }
            >
                <AgentLoanApplicationMerchantSnapshotSalesTable
                    sales={filteredSales}
                />
            </Card>
        );
    },
);

const salesTypeOptions = [
    {
        value: AgentLoanApplicationSalesType.MONTHLY,
        label: <Trans i18nKey="Agent.Merchant.Sales.Monthly" />,
    },
    {
        value: AgentLoanApplicationSalesType.WEEKLY,
        label: <Trans i18nKey="Agent.Merchant.Sales.Weekly" />,
    },
];
